export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4619.cdfd4a96.jpg";